const normalized_search_value = (value = '') => {
    const textValue = value === null || value === undefined ? '' : value;

    return `${textValue}`
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
};

const compact_search_value = (value = '') => {
    return normalized_search_value(value).replace(/[^a-z0-9]/g, '');
};

const primitive_search_text = (value = '') => {
    const normalizedValue = normalized_search_value(value);
    const compactValue = compact_search_value(value);

    if (!normalizedValue.length) {
        return '';
    }

    if (compactValue.length && compactValue !== normalizedValue) {
        return `${normalizedValue} ${compactValue}`;
    }

    return normalizedValue;
};

const search_text_from_value = (value) => {
    if (value === null || value === undefined) {
        return '';
    }

    if (Array.isArray(value)) {
        return value.map((valueItem) => search_text_from_value(valueItem)).join(' ');
    }

    if (typeof value === 'object') {
        return Object.values(value).map((valueItem) => search_text_from_value(valueItem)).join(' ');
    }

    return primitive_search_text(value);
};

export const object_matches_search = (value, searchValue = '') => {
    const normalizedSearch = normalized_search_value(searchValue);
    const compactSearch = compact_search_value(searchValue);
    const searchText = search_text_from_value(value);
    const compactSearchText = compact_search_value(searchText);

    if (!normalizedSearch.length && !compactSearch.length) {
        return true;
    }

    const matchesNormalizedSearch = normalizedSearch.length && searchText.includes(normalizedSearch);
    const matchesCompactSearch = compactSearch.length && compactSearchText.includes(compactSearch);

    return Boolean(matchesNormalizedSearch || matchesCompactSearch);
};
